import React, { useEffect, useState } from "react";
import axios from "axios";
import CountUp from 'react-countup';
import { values } from "lodash";

const Homes = () => {
    const [publicationData, setPublicationData] = useState({});
    const [projectData, setProjectData] = useState({});
    const [moudata, setMoudata] = useState({});
    const [patentdata, setPatentData] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [selectedDept, setSelectedDept] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL || 'https://ooo-toddler-gifts-pubs.trycloudflare.como.trycloudflare.com'}/api/departments`);
                const deptData = response.data;
                setDepartments(deptData); // Store all departments
                setLoading(false);
            } catch (err) {
                setError("Failed to fetch department data.");
                setLoading(false);
            }
        };
        fetchDepartments();
    }, []);

    useEffect(() => {
        const fetchMoudata = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/mous/department-publications`);
                const deptData = response.data;
                setMoudata(deptData);
                setLoading(false);
            } catch (err) {
                setError("Failed to fetch MOU data.");
                setLoading(false);
            }
        };
        fetchMoudata();
    }, []);

    useEffect(() => {
        const fetchPublicationData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/publications/department-publications`);
                setPublicationData(response.data);
            } catch (err) {
                setError("Failed to fetch publication data.");
                setLoading(false);
            }
        };
        fetchPublicationData();
    }, []);

    useEffect(() => {
        const fetchPatentData = async () => {
            let allPatents = [];
            let nextPageUrl = `${process.env.REACT_APP_API_BASE_URL}/api/patents`; // initial API endpoint
           
            try {
                while (nextPageUrl) {
                    if (nextPageUrl.startsWith('http://') && process.env.REACT_APP_API_BASE_URL?.startsWith('https://')) {
                        nextPageUrl = nextPageUrl.replace('http://', 'https://');
                    }
                    const response = await axios.get(nextPageUrl);
                    const patents = response.data?._embedded?.patents || [];
                    allPatents = [...allPatents, ...patents];

                    nextPageUrl = response.data?._links?.next?.href || null;
                }

                setPatentData(allPatents);
                setLoading(false);
            } catch (err) {
                setError("Failed to fetch patent data.");
                setLoading(false);
            }
        };

        fetchPatentData();
    }, []);

    useEffect(() => {
        const fetchProjectData = async () => {
            try {
                const validDepartments = departments.filter(dept => dept && dept.deptId);
                const responses = await Promise.all(
                    validDepartments.map(dept =>
                        axios.get(`${process.env.REACT_APP_API_BASE_URL || 'https://ooo-toddler-gifts-pubs.trycloudflare.como.trycloudflare.com'}/api/project-departments/project-type-count/${dept.deptId}`)
                    )
                );

                const allProjectData = {};
                responses.forEach((response, index) => {
                    allProjectData[validDepartments[index].deptName] = response.data;
                });

                setProjectData(allProjectData);
                
            } catch (err) {
                setError("Failed to fetch project data.");
            }
        };

        if (departments.length > 0) {
            fetchProjectData();
        }
    }, [departments]);
  


    const getDepartmentName = (deptId) => {
        const dept = departments.find(d => d.deptId === deptId);
        return dept ? dept.deptName.trim() : "Unknown Department"; 
    };
    

    const patentCount = selectedDept
        ? patentdata.filter(patent => {
            // Extract the department ID from patent data
            const departmentId = patent.department.trim(); // Assuming patent.department is deptId
            const departmentName = getDepartmentName(departmentId); // Map ID to department name
            
            console.log("Patent Department ID:", departmentId);
            console.log("Patent Department Name:", departmentName);
            
            // Compare extracted department name with selected department name
            return departmentName === selectedDept;
        }).length
        : patentdata.length;

    // Log the final patent count
    console.log("Final Patent Count:", patentCount);

    const departmentName = selectedDept ? selectedDept : "All Department";
    const publicationCount = selectedDept
    ? publicationData[selectedDept] || 0
    : Object.values(publicationData || {}).reduce((a, b) => a + b, 0) + 1; // Increase by 1 only for "All Departments"


    const projectCount = selectedDept
        ? (projectData[selectedDept] ? Object.values(projectData[selectedDept]).reduce((a, b) => a + b, 0) : 0)
        : Object.keys(projectData).reduce((total, deptName) => {
              const projectCounts = Object.values(projectData[deptName]);
              return total + projectCounts.reduce((a, b) => a + b, 0);
              
        }, 0);
        // Store project count in localStorage only if it's not already set
    localStorage.setItem("projectCount", projectCount);




    const MouCount = selectedDept
        ? moudata[selectedDept] || 0
        : Object.values(moudata).reduce((total, count) => total + count, 0)+1;

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <div className="container pt-2">
            {/* Department Filter Dropdown */}
            <div className="text-center mb-1">
                <div className="d-flex align-items-center mb-2">
                    <select
                        id="dept-select"
                        value={selectedDept || ""}
                        onChange={(e) => setSelectedDept(e.target.value)}
                        className="form-select"
                        style={{ width: '250px' }}
                    >
                        <option value="">All Departments</option>
                        {departments.map(dept => (
                            <option key={dept.deptId} value={dept.deptName}>
                                {dept.deptName}
                            </option>
                        ))}
                    </select>
                </div>
            </div>

            {/* Cards Layout */}
            <div className="row g-4">
                {/* Publication Count Card */}
                <div className="col-md-6">
                    <div
                        className="shadow-sm border rounded h-100 p-3"
                        style={{
                            background: 'linear-gradient(45deg, #FF6F61, #FFB6B9)',
                            transform: 'scale(1.05)',
                        }}
                    >
                        <div className="text-center">
                            <h5 className="text-black fs-5">{departmentName} Publications</h5>
                            <p className="h4 fw-bold text-black">
                                <CountUp start={0} end={publicationCount} duration={2} />
                            </p>
                        </div>
                    </div>
                </div>

                {/* Project Count Card */}
                <div className="col-md-6">
                    <div
                        className="shadow-sm border rounded h-100 p-3"
                        style={{
                            background: 'linear-gradient(90deg, #4C9FFF, #A7C7E7)',
                            transform: 'scale(1.05)',
                        }}
                    >
                        <div className="text-center">
                            <h5 className="text-black fs-5">{departmentName} Projects</h5>
                            <p className="h4 fw-bold text-black">
                                <CountUp start={0} end={projectCount} duration={2.5} />
                            </p>
                        </div>
                    </div>
                </div>

                {/* MOU Count Card */}
                <div className="col-md-6">
                    <div
                        className="shadow-sm border rounded h-100 p-3"
                        style={{
                            background: 'linear-gradient(45deg, #20c997, #17a2b8)',
                            transform: 'scale(1.05)',
                        }}
                    >
                        <div className="text-center">
                            <h5 className="text-black fs-5">{departmentName} MOU's</h5>
                            <p className="h4 fw-bold text-black">
                                <CountUp start={0} end={MouCount} duration={3} />
                            </p>
                        </div>
                    </div>
                </div>

                {/* Patents Count Card */}
                <div className="col-md-6">
                    <div
                        className="shadow-sm border rounded h-100 p-3"
                        style={{
                            background: 'linear-gradient(135deg, #FFB74D, #FFEB8E)',
                            transform: 'scale(1.05)',
                        }}
                    >
                        <div className="text-center">
                            <h5 className="text-black fs-5">{departmentName} Patents</h5>
                            <p className="h4 fw-bold text-black">
                                <CountUp start={0} end={patentCount} duration={2} />
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Homes;
